import { inject, Pipe, PipeTransform } from '@angular/core';
import { DateFormatService } from '@modules/common/services/date-format.service';

@Pipe({
  name: 'formatSendLater',
  pure: true,
  standalone: false,
})
export class FormatSendLaterPipe implements PipeTransform {
  private readonly dateFormatService = inject(DateFormatService);

  transform(value: Date | null | undefined): string {
    if (!value) {
      return '';
    }

    const date = value instanceof Date ? value : new Date(value);
    return this.dateFormatService.formatDateTime(date);
  }
}
